import Axios, { REQUEST_METHOD } from "../axios";

export function apiGetCurrentTournamentRound() {
  return Axios.fetch({
    url: "/tournament/fetch-current-round-record",
    method: REQUEST_METHOD.GET,
  });
}

export function apiPurgeLastFinalistRoundChampionShipPrep({ advanceStage }) {
  return Axios.fetch({
    url: "/tournament/purge-finalists-round",
    method: REQUEST_METHOD.POST,
    data: { advanceStage },
  });
}

export function apiBeginTournamentYear(payload) {
  return Axios.fetch({
    url: "/tournament/begin-tournament-year",
    method: REQUEST_METHOD.POST,
    data: payload,
  });
}

export function apiCreateNextFinalsTournamentRoundOnThisRecord(
  roundId,
  payload
) {
  return Axios.fetch({
    url: `/tournament/create-next-finals-round-on-this-record/${roundId}`,
    method: REQUEST_METHOD.PATCH,
    data: payload, // { status:"closed", period:"opensToday" }
  });
}

export function apiUpdateTournamentRound(roundId, patch) {
  return Axios.fetch({
    url: `/tournament/update-round-record/${roundId}`,
    method: REQUEST_METHOD.PATCH,
    data: patch,
  });
}

export function apiDecideRound(roundId, patch) {
  return Axios.fetch({
    url: `/tournament/decide-round/${roundId}`,
    method: REQUEST_METHOD.PATCH,
    data: patch, // { status: "deciding", period: "ended" }
  });
}

export function apiApproveNextSeason(payload) {
  return Axios.fetch({
    url: `/tournament/approve-next-season`,
    method: REQUEST_METHOD.POST,
    data: payload, // ✅ body
  });
}

export function apiCreateNextChampionshipRoundOnThisRecord(roundId, payload) {
  return Axios.fetch({
    url: `/tournament/create-next-championship-round-on-this-record/${roundId}`,
    method: REQUEST_METHOD.PATCH,
    data: payload, // ✅ UI intent patch: { status, period } etc
  });
}

export default {
  apiUpdateTournamentRound,
  apiPurgeLastFinalistRoundChampionShipPrep,
  apiGetCurrentTournamentRound,
  apiUpdateTournamentRound,
  apiCreateNextFinalsTournamentRoundOnThisRecord,
  apiCreateNextChampionshipRoundOnThisRecord,
};
